const customHandlers = {}
let clientSocketConnection
let parentWindowUrl

export function init(csc, url) {
  clientSocketConnection = csc
  parentWindowUrl = url
}

export function addParentMessageHandler(messageType, handlerFn) {
  customHandlers[messageType] = handlerFn
}

export function postMessageToParent(type, data) {
  window.parent.postMessage(JSON.stringify({type, data}), parentWindowUrl)
}

window.addEventListener('message', async e => {
  if (e.origin !== parentWindowUrl) return

  const msg = JSON.parse(e.data)

  switch (msg.type) {
    case 'REQUEST':
      const {type, body} = msg.request
      const data = await clientSocketConnection.request(type, body)
      postMessageToParent(type, data)
      break
    default:
      const handler = customHandlers[msg.type]
      if (handler) handler(msg)
      break
  }
})
